import React from 'react';
import logoSvg from '../../../assets/logo.svg';

const ExternalHeader: React.FC = () => (
  <header className="sticky top-0 z-40 border-b border-gray-200 bg-white px-3 py-2.5 shadow-sm sm:px-4 sm:py-4 lg:px-6">
    <div className="flex items-center justify-between">
      <div className="flex min-w-0 items-center space-x-2 sm:space-x-3">
        <img src={logoSvg} alt="Gentari Logo" className="h-9 w-12 object-contain sm:h-12 sm:w-16" />
        <div className="hidden text-sm text-gray-600 md:block lg:text-base">
          <span className="font-medium">Employee EPM</span>
          <span className="mx-1 lg:mx-2">|</span>
          <span>360 Feedback Portal</span>
        </div>
      </div>
    </div>
  </header>
);

export default ExternalHeader;